import GiftItemApi from '@apis/gift/GiftItemApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const giftItemQueries = createQueryKeys('giftItem', {
    list: (giftCategoryId: string) => ({
        queryKey: ['giftItems', giftCategoryId],
        queryFn: () => GiftItemApi.getGiftItems({ giftCategoryId }),
    }),
    detail: (giftItemId: string) => ({
        queryKey: [giftItemId],
        queryFn: () => GiftItemApi.getGiftItem(giftItemId),
    }),
});

export default giftItemQueries;
